module.exports = __webpack_public_path__ + "static/media/id3-wild_routine.4ef61849.jpg";